import React from 'react';
import { Route } from 'react-router-dom';
import { navigationRoutes } from '@app/utils/navigation-routes';
import { BreadcrumbsItem } from '@app/layouts/layout';
import RequiredAuth from '@app/routes/required-auth.route';
import { LastProjectOutlet, LastProjectRecordsPage, SingleLastRecordPage } from '@app/pages';

export const lastRecordRoute = (
  <Route
    path={navigationRoutes.projectRecords}
    element={
      <RequiredAuth>
        <LastProjectOutlet currentTemplate="voice" />
      </RequiredAuth>
    }
    handle={{
      crumb: () => (
        <BreadcrumbsItem path={navigationRoutes.projectRecords} crumb="project_records" />
      ),
    }}
  >
    <Route index element={<LastProjectRecordsPage currentTemplate="voice" />} />
    <Route path=":recordProjectId">
      <Route path=":recordId" element={<SingleLastRecordPage currentTemplate="voice" />} />
    </Route>
  </Route>
);
